import { useQuery } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

export interface ExpiryStatusResponse {
  state: 'none' | 'normal' | 'warning' | 'urgent' | 'expired';
  days_to_expiry: number | null;
  end_date: string | null;
}

export default function useGetExpiryStatus(enabled: boolean = true) {
  return useQuery<ExpiryStatusResponse>(
    ['expiry-status'],
    async () => {
      // Real API call - user ID will be extracted from auth token on backend
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.get<ExpiryStatusResponse>(
        `subscription/v1/get-expiry-status/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled,
      staleTime: 10 * 60 * 1000, // 10 minutes
      cacheTime: 20 * 60 * 1000, // 20 minutes
    },
  );
}